import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { Content, Step } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const {
  CONTENT,
  BOOK_APPOINTMENT,
  PRESCRIPTION,
  CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
} = USA
const { WELCOME, REGISTRATION, FAMILY, SUMMARY, ELIGIBILITY } = CONTENT

const partnerName = 'Meritage Medicare Advantage'

const welcomeContent: Step = {
  ...WELCOME.enUS,
  copy: [
    'Patients with a Primary Care Provider in the Meritage Medical Network, now have access to after-hours care with the Babylon app. Data rates may apply.',
  ],
}

const content: Content = {
  'en-US': {
    steps: [
      {
        ...welcomeContent,
        productFeatures: [
          {
            ...BOOK_APPOINTMENT.enUS,
            title:
              'Unlimited virtual doctor appointments, at a time that best fits your schedule.',
          },
          {
            ...PRESCRIPTION.enUS,
            title:
              'Get prescriptions sent to a local pharmacy of your choice (restrictions may apply)',
          },
        ],
      },
      {
        ...REGISTRATION.enUS,
        copy: ['Enter your details to register'],
      },
      {
        ...FAMILY.enUS,
        copy: [
          'If your dependent’s PCP is part of the Meritage Medical Network, they can also get unlimited access to Babylon, register them now.',
          'Add your family members now so they can access our services at no extra cost.',
        ],
      },
      ELIGIBILITY.enUS,
      SUMMARY.enUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
}

const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
    id: 'meritage-medicare-advantage',
    productConfigAppName: 'meritage-medicare-advantage',
    name: partnerName,
    codes: {
      membership: 'MMN-MAAUTOAPP',
    },
    partnerUrlSlug: 'mmn-ma',
  },
  content,
}

const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
  content,
}

export default [baseConfig, baseConfigWithDnaV2Design]
